export enum UserActionType {
	FETCH_USER_DETAILS = 'FETCH_USER_DETAILS',
	STORE_USER_DETAILS = 'STORE_USER_DETAILS',
	ERROR_USER_DETAILS = 'ERROR_USER_DETAILS',

	UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS',
	UPDATE_PROFILE_PICTURE = 'UPDATE_PROFILE_PICTURE',

	FETCH_USER_PERMISSIONS = 'FETCH_USER_PERMISSIONS',
	STORE_USER_PERMISSIONS = 'STORE_USER_PERMISSIONS',
	ERROR_USER_PERMISSIONS = 'ERROR_USER_PERMISSIONS',
	UPDATE_USER_PERMISSIONS = 'UPDATE_USER_PERMISSIONS',

	FETCH_SELECTED_USER_PERMISSIONS = 'FETCH_SELECTED_USER_PERMISSIONS',
	STORE_SELECTED_USER_PERMISSIONS = 'STORE_SELECTED_USER_PERMISSIONS',
	ERROR_SELECTED_USER_PERMISSIONS = 'ERROR_SELECTED_USER_PERMISSIONS',

	FETCH_CREDITS = 'FETCH_CREDITS',
	STORE_CREDITS = 'STORE_CREDITS',
	ERROR_FETCH_CREDITS = 'ERROR_FETCH_CREDITS',

	UPDATE_CREDITS = 'UPDATE_CREDITS',
	UPDATE_CREDITS_SUCCESS = 'UPDATE_CREDITS_SUCCESS',
	ERROR_UPDATE_CREDITS = 'ERROR_UPDATE_CREDITS'
}
